import * as Phaser from "phaser-ce"
import { Gender } from "../../../shared/models/Gender"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { MakeFriendStages } from "./MakeFriendProgressStore"
import { CharacterFlavor, CharacterType } from "./sprites/MakeFriendCharacter"

export enum MakeFriendAudio {
    INTRO = "make-a-friend-n-intro.mp3",

    ATTRIBUTE_ENERGETIC = "make-a-friend-n-1-energetic.mp3",
    ATTRIBUTE_FRIENDLY = "make-a-friend-n-1-friendly.mp3",
    ATTRIBUTE_SOCIAL = "make-a-friend-n-1-social.mp3",
    ATTRIBUTE_TALKATIVE = "make-a-friend-n-1-talkative.mp3",
    ATTRIBUTE_CARING = "make-a-friend-n-2-caring.mp3",
    ATTRIBUTE_GENEROUS = "make-a-friend-n-2-generous.mp3",
    ATTRIBUTE_HELPFUL = "make-a-friend-n-2-helpful.mp3",
    ATTRIBUTE_KIND = "make-a-friend-n-2-kind.mp3",
    ATTRIBUTE_CAREFUL = "make-a-friend-n-3-careful.mp3",
    ATTRIBUTE_HARDWORKING = "make-a-friend-n-3-hardworking.mp3",
    ATTRIBUTE_HONEST = "make-a-friend-n-3-honest.mp3",
    ATTRIBUTE_RESPONSIBLE = "make-a-friend-n-3-responsible.mp3",
    ATTRIBUTE_EASYGOING = "make-a-friend-n-4-easygoing.mp3",
    ATTRIBUTE_FUNNY = "make-a-friend-n-4-funny.mp3",
    ATTRIBUTE_HAPPY = "make-a-friend-n-4-happy.mp3",
    ATTRIBUTE_QUIET = "make-a-friend-n-4-quiet.mp3",
    ATTRIBUTE_ARTISTIC = "make-a-friend-n-5-artistic.mp3",
    ATTRIBUTE_CREATIVE = "make-a-friend-n-5-creative.mp3",
    ATTRIBUTE_CURIOUS = "make-a-friend-n-5-curious.mp3",
    ATTRIBUTE_SMART = "make-a-friend-n-5-smart.mp3",

    PICK_FIVE_WORDS = "make-a-friend-n-6.mp3",
    CHOOSE_YOUR_VIRTUAL_SELF = "make-a-friend-n-7.mp3",
    BASED_ON_THE_PERSONALITY_CHARACTERISTICS = "make-a-friend-n-8.mp3",

    HERES_YOUR_NEW_FRIEND_BEN = "make-a-friend-n-9-boy.mp3",
    HERES_YOUR_NEW_FRIEND_SARAH = "make-a-friend-n-9-girl.mp3",

    CHOOSE_YOUR_APPEARANCE = "make-a-friend-n-10.mp3",
    WHAT_DO_YOU_AND_YOUR_FRIEND_WANT_TO_DO = "make-a-friend-n-11.mp3",

    FIRST_STAGE_SELECTION = "make-a-friend-n-12.mp3",
    SECOND_STAGE_SELECTION = "make-a-friend-n-15.mp3",
    THIRD_STAGE_SELECTION = "make-a-friend-n-17.mp3",

    PICK_WHAT_YOU_WANT_TO_SAY = "make-a-friend-n-13.mp3",

    ARCADE_END = "make-a-friend-n-14.mp3",
    PARTY_END = "make-a-friend-n-16.mp3",
    POOL_END = "make-a-friend-n-18.mp3",

    OUTRO = "make-a-friend-n-outro.mp3"
}

export enum MakeFriendImages {
    PAPERDOLL_BOY = "paperdoll-boy.png",
    PAPERDOLL_GIRL = "paperdoll-girl.png",
    ARROW_LEFT = "arrow-left.png",
    ARROW_RIGHT = "arrow-right.png",
    STAGE_ARCADE = "stage-arcade.png",
    STAGE_HOUSE = "stage-house.png",
    STAGE_POOL = "stage-pool.png",

    BLACK_SCREEN = "black-screen.png",

    ARCADE_EXTERIOR_BOY = "arcade/exterior-boy.png",
    ARCADE_EXTERIOR_GIRL = "arcade/exterior-girl.png",
    ARCADE_INTERIOR_BOY = "arcade/interior-boy.png",
    ARCADE_INTERIOR_GIRL = "arcade/interior-girl.png",

    SLEEPOVER_ROOM_BOY = "sleepover/room-boy.png",
    SLEEPOVER_ROOM_GIRL = "sleepover/room-girl.png",
    SLEEPOVER_PARTY_OUTSIDE_BOY = "sleepover/party-outside-boy.png",
    SLEEPOVER_PARTY_OUTSIDE_GIRL = "sleepover/party-outside-girl.png",
    SLEEPOVER_PARTY_OUTSIDE_SMOKER_BOY = "sleepover/smoker-boy.png",
    SLEEPOVER_PARTY_OUTSIDE_SMOKER_GIRL = "sleepover/smoker-girl.png",
    SLEEPOVER_PARTY_INSIDE_BOY = "sleepover/party-inside-boy.png",
    SLEEPOVER_PARTY_INSIDE_GIRL = "sleepover/party-inside-girl.png",
    SLEEPOVER_PARTY_INSIDE_FOREGROUND = "sleepover/party-inside-foreground.png",

    POOL_IN_BLUE_BOY = "pool/in-blue-boy.png",
    POOL_IN_BLUE_GIRL = "pool/in-blue-girl.png",
    POOL_OUT_BACKGROUND = "pool/out-background.png",
    POOL_OUT_FOREGROUND_BOY = "pool/out-foreground-boy.png",
    POOL_OUT_FOREGROUND_GIRL = "pool/out-foreground-girl.png",

    POOL_IN_YELLOW_BOY = "pool/in-yellow-boy.png",
    POOL_IN_YELLOW_GIRL = "pool/in-yellow-girl.png"
}

export enum MakeFriendAtlases {
    INTRO_YOU_BOY = "intro-you-boy.json",
    INTRO_FRIEND_BOY = "intro-friend-boy.json",
    INTRO_YOU_GIRL = "intro-you-girl.json",
    INTRO_FRIEND_GIRL = "intro-friend-girl.json",

    ARCADE_OUTSIDE_YOU_BOY = "arcade-outside-you-boy.json",
    ARCADE_OUTSIDE_FRIEND_BOY = "arcade-outside-friend-boy.json",
    ARCADE_OUTSIDE_YOU_GIRL = "arcade-outside-you-girl.json",
    ARCADE_OUTSIDE_FRIEND_GIRL = "arcade-outside-friend-girl.json",
    ARCADE_INSIDE_YOU_BOY = "arcade-inside-you-boy.json",
    ARCADE_INSIDE_FRIEND_BOY = "arcade-inside-friend-boy.json",
    ARCADE_INSIDE_YOU_GIRL = "arcade-inside-you-girl.json",
    ARCADE_INSIDE_FRIEND_GIRL = "arcade-inside-friend-girl.json",

    POOL_IN_YOU_BOY = "pool-in-you-boy.json",
    POOL_IN_FRIEND_BOY = "pool-in-friend-boy.json",
    POOL_IN_YOU_GIRL = "pool-in-you-girl.json",
    POOL_IN_FRIEND_GIRL = "pool-in-friend-girl.json",
    POOL_OUT_YOU_BOY = "pool-out-you-boy.json",
    POOL_OUT_FRIEND_BOY = "pool-out-friend-boy.json",
    POOL_OUT_YOU_GIRL = "pool-out-you-girl.json",
    POOL_OUT_FRIEND_GIRL = "pool-out-friend-girl.json",

    SLEEPOVER_BEDROOM_YOU_BOY = "sleepover-bedroom-you-boy.json",
    SLEEPOVER_BEDROOM_FRIEND_BOY = "sleepover-bedroom-friend-boy.json",
    SLEEPOVER_BEDROOM_YOU_GIRL = "sleepover-bedroom-you-girl.json",
    SLEEPOVER_BEDROOM_FRIEND_GIRL = "sleepover-bedroom-friend-girl.json",
    SLEEPOVER_OUTSIDE_YOU_BOY = "sleepover-outside-you-boy.json",
    SLEEPOVER_OUTSIDE_FRIEND_BOY = "sleepover-outside-friend-boy.json",
    SLEEPOVER_OUTSIDE_YOU_GIRL = "sleepover-outside-you-girl.json",
    SLEEPOVER_OUTSIDE_FRIEND_GIRL = "sleepover-outside-friend-girl.json",
    SLEEPOVER_INSIDE_YOU_BOY = "sleepover-inside-you-boy.json",
    SLEEPOVER_INSIDE_FRIEND_BOY = "sleepover-inside-friend-boy.json",
    SLEEPOVER_INSIDE_YOU_GIRL = "sleepover-inside-you-girl.json",
    SLEEPOVER_INSIDE_FRIEND_GIRL = "sleepover-inside-friend-girl.json"
}

export class MakeFriendAssets {
    static getAvatarSampleAudio = (gender: Gender, flavor: CharacterFlavor) => {
        let number
        switch (flavor) {
            case CharacterFlavor.ONE:
                number = 1
                break
            case CharacterFlavor.TWO:
                number = 2
                break
            case CharacterFlavor.THREE:
                number = 3
                break
        }
        return `make-a-friend-avatar-${number}-sample-${gender.toLowerCase()}.mp3`
    }

    static getStageAudio = (stage: MakeFriendStages, type: CharacterType, gender: Gender, number: number, flavor?: CharacterFlavor) => {
        let name: string
        let stageName: string
        let npcType = 'vaper'
        const genderName: string = gender.toLowerCase()
        switch (stage) {
            case MakeFriendStages.ARCADE:
                stageName = 'arcade'
                break
            case MakeFriendStages.SLEEPOVER:
                stageName = 'sleepover'
                npcType = 'smoker'
                break
            case MakeFriendStages.POOL:
                stageName = 'pool'
                break
        }
        switch (type) {
            case CharacterType.YOU:
                switch (flavor) {
                    case CharacterFlavor.ONE:
                        name = `make-a-friend-avatar-1-${stageName}-${number}-${genderName}.mp3`
                        break
                    case CharacterFlavor.TWO:
                        name = `make-a-friend-avatar-2-${stageName}-${number}-${genderName}.mp3`
                        break
                    case CharacterFlavor.THREE:
                        name = `make-a-friend-avatar-3-${stageName}-${number}-${genderName}.mp3`
                        break
                }
                break
            case CharacterType.FRIEND:
                name = `make-a-friend-friend-${stageName}-${number}-${genderName}.mp3`
                break
            case CharacterType.SMOKER:
                switch (stage) {
                    case MakeFriendStages.ARCADE:
                    case MakeFriendStages.POOL:
                        name = `make-a-friend-${stageName}-${npcType}-${number}-${genderName}.mp3`
                        break
                    case MakeFriendStages.SLEEPOVER:
                        name = `make-a-friend-${npcType}-${stageName}-${number}-${genderName}.mp3`
                        break
                }
                break
        }
        return name
    }
}

function rangeArray(i){return i ? rangeArray(i-1).concat(i):[]}

export const loadAssets = (game: Phaser.Game) => {
    const load = PhaserUtils.makeLoader(game, "make-friend")
    load.autoLoad({imageEnum: MakeFriendImages, audioEnum: MakeFriendAudio, atlasEnum: MakeFriendAtlases})

    const genders = [Gender.BOY, Gender.GIRL]
    const flavors = [CharacterFlavor.ONE, CharacterFlavor.TWO, CharacterFlavor.THREE]
    genders.forEach(gender => {
        // Smoker
        rangeArray(3).forEach(number => {
            const name = MakeFriendAssets.getStageAudio(MakeFriendStages.ARCADE, CharacterType.SMOKER, gender, number)
            load.audio(name, name)
            const name1 = MakeFriendAssets.getStageAudio(MakeFriendStages.SLEEPOVER, CharacterType.SMOKER, gender, number)
            load.audio(name1, name1)
        })
        rangeArray(2).forEach(number => {
            const name = MakeFriendAssets.getStageAudio(MakeFriendStages.POOL, CharacterType.SMOKER, gender, number)
            load.audio(name, name)
        })

        // Friend
        rangeArray(5).forEach(number => {
            const name = MakeFriendAssets.getStageAudio(MakeFriendStages.ARCADE, CharacterType.FRIEND, gender, number)
            load.audio(name, name)
            const name1 = MakeFriendAssets.getStageAudio(MakeFriendStages.SLEEPOVER, CharacterType.FRIEND, gender, number)
            load.audio(name1, name1)
        })
        rangeArray(6).forEach(number => {
            const name = MakeFriendAssets.getStageAudio(MakeFriendStages.POOL, CharacterType.FRIEND, gender, number)
            load.audio(name, name)
        })

        // You
        flavors.forEach(flavor => {
            const name = MakeFriendAssets.getAvatarSampleAudio(gender, flavor)
            load.audio(name, name)
            rangeArray(6).forEach(number => {
                const name = MakeFriendAssets.getStageAudio(MakeFriendStages.ARCADE, CharacterType.YOU, gender, number, flavor)
                load.audio(name, name)
                const name1 = MakeFriendAssets.getStageAudio(MakeFriendStages.SLEEPOVER, CharacterType.YOU, gender, number, flavor)
                load.audio(name1, name1)
                const name2 = MakeFriendAssets.getStageAudio(MakeFriendStages.POOL, CharacterType.YOU, gender, number, flavor)
                load.audio(name2, name2)
            })
        })
    })
}

